import { useEffect, useState } from "react";
import { Truck, FileSpreadsheet, RefreshCw } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import api, { formatApiError } from "@/lib/api";
import GestionPedidos from "@/components/traspasos/GestionPedidos";
import ImportarPedidoDialog from "@/components/traspasos/ImportarPedidoDialog";

/** ERP de almacén (CDMX / CEDIS Oaxaca): todo lo que sale de mi almacén — traspasos a sucursales y ventas a sucursales inversionistas, franquicias y CEDIS. */
export default function TraspasosVentas() {
  const { user } = useAuth();
  const [alm, setAlm] = useState(null);
  const [importar, setImportar] = useState(false);
  const [ver, setVer] = useState(0);
  const [reenviando, setReenviando] = useState(false);
  async function reenviarHub() {
    setReenviando(true);
    try {
      const { data } = await api.post("/integraciones/rubinova/reposiciones/reenviar", {});
      toast.success(`RubiNOVA: ${data.nuevos} pedido(s) nuevo(s) enviado(s) · ${data.actualizados} actualizado(s)${data.folios.length ? ` · ${data.folios.slice(0, 6).join(", ")}${data.folios.length > 6 ? "…" : ""}` : ""}`, { duration: 9000 });
      setTimeout(() => setVer((n) => n + 1), 4000);
    } catch (e) { toast.error(formatApiError(e)); } finally { setReenviando(false); }
  }
  useEffect(() => { api.get("/sucursales").then((r) => setAlm(r.data.find((s) => ["almacen", "cedis"].includes(s.tipo) && (!user?.cedis_id || s.id === user.cedis_id)) || r.data.find((s) => ["almacen", "cedis"].includes(s.tipo)))).catch(() => {}); }, [user]);
  return (
    <div className="p-4 sm:p-6 lg:p-8 max-w-[1500px] mx-auto animate-fade-up" data-testid="traspasos-ventas-page">
      <div className="mb-5 flex items-start justify-between flex-wrap gap-4">
        <div>
          <div className="eyebrow mb-1">Operación · {alm?.nombre || "Almacén"}</div>
          <h1 className="font-display text-2xl sm:text-3xl font-extrabold tracking-tight text-brand-ink flex items-center gap-2"><Truck className="w-7 h-7 text-brand-amber" /> Traspasos y ventas</h1>
          <p className="text-sm text-brand-muted mt-1">Salidas de tu almacén: traspasos a sucursales propias y ventas de insumos a sucursales, franquicias y CEDIS. Filtra por estado, destino, cobro y fecha; imprime hoja y etiquetas de preparación.</p>
        </div>
        <div className="flex gap-2 flex-wrap">
          <button data-testid="tv-reenviar-hub" onClick={reenviarHub} disabled={reenviando} className="btn-soft h-11 px-4 text-sm" title="Envía al hub de RubiNOVA los pedidos activos que no llegaron y actualiza los que ya están"><RefreshCw className={`w-4 h-4 ${reenviando ? "animate-spin" : ""}`} /> Reenviar a RubiNOVA</button>
          <button data-testid="tv-importar-excel" onClick={() => setImportar(true)} disabled={!alm} className="btn-amber h-11 px-4 text-sm"><FileSpreadsheet className="w-4 h-4" /> Pedido desde Excel</button>
        </div>
      </div>
      <GestionPedidos key={ver} direccion="salida" esOrigen user={user} />
      {alm && <ImportarPedidoDialog open={importar} onClose={() => setImportar(false)} origenId={alm.id} onCreado={() => setVer((n) => n + 1)} />}
    </div>
  );
}
